import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faMoon, faSun , faSearch , faChevronDown , faChevronUp , faArrowLeft} from '@fortawesome/free-solid-svg-icons';

library.add(fas,
  faMoon,
  faSun,
  faSearch,
  faChevronDown,
  faChevronUp,
  faArrowLeft
  // more icons go here
);